export default __webpack_public_path__ + "static/media/next.8a99b56f.svg";